import ForgotPasswordPage from 'Shared/users/ForgotPasswordPage';
import { lazy } from 'solid-js';


/* Routes shared with artist GUI */
export function sharedLoginRoutes()
{
	return [
		{
			path: '/forgotPassword',
//XXX At the time of writing the lazy() version was giving a rando Solid error when run in server mode (not Vite)
//			component: lazy(() => import('Shared/users/ForgotPasswordPage')),
			component: ForgotPasswordPage
		},
		{
			path: '/resetPassword/:key',
			component: lazy(() => import('Shared/users/ResetPasswordPage')),
		},
		{
			path: '/setPasswordAtRegistration/:key',
			component: lazy(() => import('Shared/users/SetPasswordAtRegistrationPage')),
		},
	];
}


